import React, {useState} from 'react'
import './style.css'
import {Container, Row, Col} from 'react-bootstrap'
import {Link} from 'react-router-dom'
import NavJudul from 'components/componentsmall/nav_judul'
import Product from './product'
import Popup from './popup'
import AkunKurir from './akun_kurir'
import Kupon from './kupon'

export default function index() {
    return (
        <Container className="checkout-pages">
            <NavJudul />
            <h4>Checkout</h4>
            <Link className="links">
                <img src="asset/home/icons/back.svg" alt="back" />
                <p>Halaman Keranjang</p>
            </Link>
                <Row>
                    <Col md={8}>
                        <h4 className="alamat-pengirim">Alamat Pengirim</h4>
                        <Alamat />
                        <Row>
                            <Col md={8}><Product /></Col>
                            <Col md={4}>
                                <Pengirim />
                            </Col>     
                        </Row>
                    </Col>
                    <Col md={4}><Pembayaran /></Col>
                </Row>
        </Container>
    )
}

const Alamat = () => {
    return (
        <div className="checkout-alamat">
        <div className="checkout-border"></div>
            <div className="alamat-detils">
                <div className="alamat">
                <h3>Rumah Ibu Naila</h3>
                <p className="name">Naila</p>
                <p className="phone">0853 4186 4089</p>
                <p className="alamat-detail">Pondok Informatika Abdesir, Jln. Bontobila I, Batua, Makassar, Sulawesi Selatan</p>
            </div>
            <Link to="#" className="edit-alamat">
                Ubah Alamat
            </Link>
          </div>
    </div>
    )
}

function Pengirim() {

    const [selected, setSelected] = useState(false)

    const clickSelect = (e) => {
        if(e.target.value === "SiCepat") {
            setSelected(true)
        } else {
            setSelected(false)
        } 
    }

    return (
        <div className="compenent-pengiriman">
        <h3 style={{textAlign:"left"}}>Pengiriman</h3>
        <select onClick={clickSelect} className="form-select">
            <option defaultValue>Pilih Pengiriman</option>
            <option value="1">Dalam Daerah(COD)</option>
            <option value="2">Reguler(Rp.14.000-Rp.20.000)</option>
            <optgroup label="Kurir Ku">
                <option>JNE</option>
                <option>JNT</option>
                <option>SiCepat</option>
            </optgroup>
        </select>
        {
            selected && 
            <AkunKurir />
        }
         <div className="kupon">
            <Kupon />
            <select>
                <option defaultValue>Gunakan kupon/kode</option>
            </select>
         </div>
        </div>
    )
}

function Pembayaran() {
    const [clickImg, setClickImg] = useState()

    let handleClick = i => {
        if(clickImg === i) {
            return setClickImg(null)
        }
        setClickImg(i)
    }

    return (    
        <div className="detile-pembayaran">
            <h3>Detail Pembayaran</h3>
            <div className="price">
                <p>Total Harga</p>
                <p>Rp. 160.000</p>
            </div>
            <div className="ongkir">
                <p>Total Ongkos Kirim</p>
                <p>Rp. 0.000</p>
            </div>
            <div className="tagihan">
                <h6>Total Tagihan</h6>
                <h5>Rp. 160.000</h5>
            </div>
            <h4>Metode Pembayaran</h4>
            {
                Radios.map((text, i) => {
                    return (
                        <div onClick={_ => handleClick(i)} key={i} className="radio-group">
                            <img src={clickImg  === i ? "asset/product/radio1.svg" : (text.src)} alt="radio" />
                            <p className={clickImg === i ? null  : "text-active"}>{text.text}</p>
                        </div>  
                    )
                })
            }
            <Popup />
        </div>
    )
}

const Radios = [
    {src:"asset/product/radio2.svg", text:"Transfer Bank"},{src:"asset/product/radio2.svg", text:"Cash on Delivery (COD)"} 
]
